import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Gallery } from "@/components/Gallery";
import { CatalogList } from "@/components/CatalogList";
import { LeadForm } from "@/components/LeadForm";
import { Footer } from "@/components/Footer";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function LandingPage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Gallery />
        <CatalogList />
        <LeadForm />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <div className="App" data-testid="app-root">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}
